import { useCallback, useMemo } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import type { IRangeValue } from "~/types/range";

export const useLiquidityRangeFilter = () => {
  const { filters, updateFilters } = useFiltersScope();

  const initialValue = useMemo(
    () => ({
      min: filters.minLiquidity,
      max: filters.maxLiquidity,
    }),
    [filters.maxLiquidity, filters.minLiquidity]
  );

  const onChangeLiquidityFilter = useCallback(
    (value?: IRangeValue) => {
      updateFilters({ minLiquidity: value?.min, maxLiquidity: value?.max });
    },
    [updateFilters]
  );

  return { onChangeLiquidityFilter, initialValue };
};
